<div class="cm-output">
    <cm-template-node [node]="$output()" [tooltip]="$tooltip()" [alwaysEnabled]="true"></cm-template-node>
</div>
